





























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import SubscriptionPlan from '@/models/payment/SubscriptionPlan';
import PaymentPlanComponent from './PaymentPlan.vue';

@Component({
    components:
    {
        PaymentPlanComponent,
    }
})
export default class PlanSelector extends Vue
{
    @Prop(Boolean) readonly project! : Boolean; // default false
    @Prop() readonly plans?: SubscriptionPlan[];
    @Prop(SubscriptionPlan) readonly activeSubPlan?: SubscriptionPlan;

    selectedTier = 1;
    tiers = [
        { text: '20 Members', value: 1},
        { text: '50 Members', value: 2},
        { text: '100 Members', value: 3},
        { text: '250 Members', value: 4}
    ];

    get filteredPlans()
    {
        if (this.plans)
        {
            return this.plans.filter((p) => (!(this.project) || p.id.includes(`tier${this.selectedTier}`)) && (this.activeSubPlan == null || p.id !== this.activeSubPlan.id));
        }
        return [];
    }
}
